import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getRandom, getRangeValue, initParticleNumericAnimationValue } from "tsparticles-engine";
import { updateOpacity } from "./Utils";
export var OpacityUpdater = /*#__PURE__*/function () {
  function OpacityUpdater(container) {
    _classCallCheck(this, OpacityUpdater);

    this.container = container;
  }

  _createClass(OpacityUpdater, [{
    key: "init",
    value: function init(particle) {
      var opacityOptions = particle.options.opacity;
      particle.opacity = initParticleNumericAnimationValue(opacityOptions, 1);
      var opacityAnimation = opacityOptions.animation;

      if (opacityAnimation.enable) {
        particle.opacity.velocity = getRangeValue(opacityAnimation.speed) / 100 * this.container.retina.reduceFactor;

        if (!opacityAnimation.sync) {
          particle.opacity.velocity *= getRandom();
        }
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      var _particle$opacity$max, _particle$opacity$max2, _particle$opacity$loo, _particle$opacity$max3;

      return !particle.destroyed && !particle.spawning && !!particle.opacity && particle.opacity.enable && (((_particle$opacity$max = particle.opacity.maxLoops) !== null && _particle$opacity$max !== void 0 ? _particle$opacity$max : 0) <= 0 || ((_particle$opacity$max2 = particle.opacity.maxLoops) !== null && _particle$opacity$max2 !== void 0 ? _particle$opacity$max2 : 0) > 0 && ((_particle$opacity$loo = particle.opacity.loops) !== null && _particle$opacity$loo !== void 0 ? _particle$opacity$loo : 0) < ((_particle$opacity$max3 = particle.opacity.maxLoops) !== null && _particle$opacity$max3 !== void 0 ? _particle$opacity$max3 : 0));
    }
  }, {
    key: "reset",
    value: function reset(particle) {
      if (particle.opacity) {
        particle.opacity.time = 0;
        particle.opacity.loops = 0;
      }
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      if (!this.isEnabled(particle)) {
        return;
      }

      updateOpacity(particle, delta);
    }
  }]);

  return OpacityUpdater;
}();